import { LineHeight } from '@billy/design-system'
import styled from '@emotion/styled'

interface LogoWrapperProps {
  clickable?: boolean
}

export const LogoWrapper = styled.figure<LogoWrapperProps>`
  display: flex;
  align-items: center;
  height: ${LineHeight.TextH1};
  ${({ clickable }) => clickable && 'cursor: pointer'};
`
